import { useEffect } from 'react';

export function useWakeLock() {
  useEffect(() => {
    let lock: WakeLockSentinel | null = null;
    const acquire = async () => {
      const nav = navigator as Navigator & {
        wakeLock?: { request: (kind: 'screen') => Promise<WakeLockSentinel> };
      };
      if (!nav.wakeLock) return;
      try {
        lock = await nav.wakeLock.request('screen');
      } catch (e) {
        console.warn('Wake lock failed', e);
      }
    };
    acquire();
    const onVis = () => {
      if (document.visibilityState === 'visible') acquire();
    };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      lock?.release().catch(() => undefined);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, []);
}
